import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useAuth } from 'react-oidc-context';
import { useStore } from '../../stores/store';
import PageLoader from '../page-loader/page-loader.component';
import {
  generateLocaleRoute,
  generateMyRoute,
} from '../../utils/uri/uri.utils';
import { AppRoute } from '../../constants/route';

interface Props {
  children: React.ReactNode;
}

const FreshUserRoute: React.FC<Props> = ({ children }) => {
  const {
    localizationsStore: { preferredCountryAliasCode },
    userStore: { user },
  } = useStore();

  const auth = useAuth();

  const navigate = useNavigate();

  useEffect(() => {
    if (!preferredCountryAliasCode) return;

    if (!!user && auth.isAuthenticated) {
      navigate(generateMyRoute(AppRoute.PARCEL_LIST));
    } else {
      navigate(generateLocaleRoute());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!preferredCountryAliasCode) {
    return children;
  }

  return <PageLoader />;
};

export default observer(FreshUserRoute);
